import React from 'react';

type Props = {
  style?: React.CSSProperties;
};

const LockIcon: React.FC<Props> = ({ style }) => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M10.0941 5.47912H9.42741V4.15905C9.42741 2.33736 7.93407 0.858887 6.09407 0.858887C4.25408 0.858887 2.76074 2.33736 2.76074 4.15905V5.47912H2.09408C1.36074 5.47912 0.760742 6.07315 0.760742 6.79919V13.3995C0.760742 14.1256 1.36074 14.7196 2.09408 14.7196H10.0941C10.8274 14.7196 11.4274 14.1256 11.4274 13.3995V6.79919C11.4274 6.07315 10.8274 5.47912 10.0941 5.47912ZM6.09407 11.4194C5.36074 11.4194 4.76074 10.8254 4.76074 10.0994C4.76074 9.37332 5.36074 8.77929 6.09407 8.77929C6.82741 8.77929 7.42741 9.37332 7.42741 10.0994C7.42741 10.8254 6.82741 11.4194 6.09407 11.4194ZM8.16074 5.47912H4.02741V4.15905C4.02741 3.0304 4.95407 2.11295 6.09407 2.11295C7.23407 2.11295 8.16074 3.0304 8.16074 4.15905V5.47912Z"
        fill="#5B7179"
      />
    </svg>
  );
};

export default LockIcon;
